import { render, staticRenderFns } from "./Peyman.vue?vue&type=template&id=65077d36&"
import script from "./Peyman.vue?vue&type=script&lang=js&"
export * from "./Peyman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports